<template>
  <base-page-layout ref="base-page" class="comparativo-produtos" title="Comparativo de produtos">
    <v-card>
      <v-container fluid class="filters">
        <v-row>
          <v-flex xs6>
            Selecione os produtos:
            <modal-graphql-search-content
              :error="hasProductsError"
              :error-messages="hasProductsError ? errorMessages.products : ''"
              :selected-items.sync="filters.products"
              item-type="produto"
            />
          </v-flex>

          <v-flex xs6>
            Seleciona as lojas:
            <mf-select-units-dialog
              solo
              :selected-units.sync="filters.unidades"
              :selected-units-configuration.sync="filters.units"
              :unit-error="$v.filters.units.$error"
              :units="units"
              :tag-list="tagList"
              :group-list="unitsGroups"
              enable-inactive-units-selection
              @change="clearData()"
            />
          </v-flex>
        </v-row>
        <v-row>
          <v-flex xs6>
            Datas inicial e final primeiro período <strong>(P1)</strong>:
            <mf-date-range-picker
              :initial-date.sync="filters.periods[0].initialDate"
              :final-date.sync="filters.periods[0].finalDate"
              :max="DateTime.now().toISO()"
              :error-messages="errorMessagesFirstPeriod"
              hide-details
              @input="clearData()"
            />
          </v-flex>
          <v-flex xs6>
            Datas inicial e final segundo período <strong>(P2)</strong>:
            <mf-date-range-picker
              :initial-date.sync="filters.periods[1].initialDate"
              :final-date.sync="filters.periods[1].finalDate"
              :max="DateTime.now().toISO()"
              :error-messages="errorMessagesSecondPeriod"
              hide-details
              @input="clearData()"
            />
          </v-flex>
        </v-row>

        <div class="d-flex justify-end">
          <mf-button label="Comparar" @click="getData()" />
        </div>
      </v-container>
    </v-card>
    <v-row class="mt-3">
      <v-spacer />
      <export-email-report-dialog
        button-text="Exportar resultados"
        title="Enviar relatório de comparativo de produtos"
        description="O relatório é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo CSV ou XLSX contendo todas as informações detalhadas do comparativo de produtos é enviado em anexo ao e-mail."
        :export-report-fn="exportData"
        :disabled="!data.length"
        async
        @file-format="getFileFormat"
      />
      <export-email-report-dialog
        button-text="Exportar resultados por loja"
        title="Enviar relatório de comparativo de produtos por loja"
        description="O relatório é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo CSV ou XLSX contendo todas as informações detalhadas do comparativo de produtos por loja é enviado em anexo ao e-mail."
        :export-report-fn="exportDataByUnits"
        :disabled="!data.length"
        async
        @file-format="getFileFormat"
      />
    </v-row>
    <mf-loading :loader="['product-comparisons']" :width="4" :height="70">
      <v-card v-if="data && data.length" class="py-8 px-6 mt-4 full-height">
        <DynamicScroller
          v-slot="{ item, index, active }"
          class="vue-recycle-scroller scroller direction-vertical"
          :items="data"
          :min-item-size="247"
          key-field="COD_ID_PRODUTO"
        >
          <DynamicScrollerItem :item="item" :active="active" :data-index="index">
            <product-comparative-card :key="item.COD_ID_PRODUTO" class="mb-10" :product="item" />
          </DynamicScrollerItem>
        </DynamicScroller>
      </v-card>
    </mf-loading>
  </base-page-layout>
</template>
<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ModalGraphqlSearchContent from '@/components/ModalGraphqlSearchContent.vue'
import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
import ProductComparativeCard from '../../components/ProductComparativeCard.vue'

import { mapActions, mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import { mapWaitingActions } from 'vue-wait'
import { required } from 'vuelidate/lib/validators'
import { DateTime } from 'luxon'
import { MUTATION_PRODUCTS_COMPARISONS_REPORT_PAYLOAD } from '../../graphql'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
export default {
  components: {
    BasePageLayout,
    ModalGraphqlSearchContent,
    ExportEmailReportDialog,
    ProductComparativeCard,
    DynamicScroller,
    DynamicScrollerItem,
  },
  data: () => ({
    loader: false,
    DateTime: DateTime,
    fileFormat: 'CSV',
    filters: {
      periods: [
        {
          initialDate: '',
          finalDate: '',
        },
        {
          initialDate: '',
          finalDate: '',
        },
      ],
      units: [],
      unidades: [],
      products: [],
    },
    errorMessages: {
      periods: 'Selecione uma data.',
      products: 'Selecione ao menos um produto',
    },
    selectProducts: false,
    firstPeriodMenu: false,
    data: [],
  }),

  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    hasProductsError() {
      return this.$v.filters.products.$error
    },
    errorMessagesFirstPeriod() {
      return this.$v.filters.periods.$each[0].initialDate.$error || this.$v.filters.periods.$each[0].finalDate.$error ? this.errorMessages.periods : ''
    },
    errorMessagesSecondPeriod() {
      return this.$v.filters.periods.$each[1].initialDate.$error || this.$v.filters.periods.$each[1].finalDate.$error ? this.errorMessages.periods : ''
    },
    baseExportDataVariables() {
      return {
        fileFormat: this.fileFormat,
        products: this.getListProducts(),
        firstPeriod: [this.filters.periods[0].initialDate, this.filters.periods[0].finalDate],
        secondPeriod: [this.filters.periods[1].initialDate, this.filters.periods[1].finalDate],
        unitsConfiguration: this.filters.units,
      }
    },
  },
  methods: {
    ...mapWaitingActions({
      productComparisons: 'product-comparisons',
    }),
    ...mapActions({
      productComparisonsByUnit: 'productComparisons',
    }),
    async exportData(emails) {
      return this.$apollo.mutate({
        mutation: MUTATION_PRODUCTS_COMPARISONS_REPORT_PAYLOAD,
        fetchPolicy: 'no-cache',
        variables: {
          emails,
          ...this.baseExportDataVariables,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
    async exportDataByUnits(emails) {
      return this.$apollo.mutate({
        mutation: MUTATION_PRODUCTS_COMPARISONS_REPORT_PAYLOAD,
        fetchPolicy: 'no-cache',
        variables: {
          emails,
          groupByUnit: true,
          ...this.baseExportDataVariables,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
    getFileFormat(value) {
      this.fileFormat = value
    },

    getData() {
      this.$v.$touch()

      if (this.$v.$error) return false
      this.loader = true
      let filtersSearch = cloneDeep(this.filters)
      filtersSearch.products = this.getListProducts()
      filtersSearch.periods = this.getFormatedPeriods()

      this.productComparisons(filtersSearch).then((response) => {
        this.loader = false
        this.data = response.data
      })
    },

    clearData() {
      this.data = []
    },

    getListProducts() {
      return this.filters.products.map((product) => {
        return product.sku
      })
    },

    getFormatedPeriods() {
      return this.filters.periods.map((period) => {
        return [period.initialDate, period.finalDate]
      })
    },
  },

  validations: {
    filters: {
      periods: {
        $each: {
          initialDate: { required },
          finalDate: { required },
        },
      },
      units: { required },
      products: { required },
    },
  },
}
</script>

<style lang="scss">
.comparativo-produtos {
  .filters {
    .flex {
      padding: 10px;
    }
  }
  .metrics-table {
    tr,
    th {
      text-align: center;
    }

    .fixed-width {
      width: 130px;
    }
  }
  .metric-title {
    font-weight: bold;
    margin: 20px 0 10px 2px;
  }
  .period-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .products-table {
    .positive-percent-color {
      background-color: #def1dd;
    }

    .negative-percent-color {
      background-color: #f0cccc;
    }
  }

  .action {
    text-align: center;
  }

  .comparasion-error {
    margin-top: 2px;
    padding-left: 12px;
    font-size: 12px;
    color: $vermelho-0;
  }
}
.scroller {
  height: 600px;
  overflow-y: auto;
}
</style>
